import { render } from "./Dealerguide.vue?vue&type=template&id=33de5f2c"
import script from "./Dealerguide.vue?vue&type=script&lang=js"
export * from "./Dealerguide.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__